import React, { useState } from "react";
import "../../Styles/yellowcalf.css/Invoices.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

function Invoices() {
  const [invoiceNo, setInvoiceNo] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [invoiceAmount, setInvoiceAmount] = useState("");
  const [hoveredRow, setHoveredRow] = useState(null); 

  const handleClear = () => {
    setInvoiceNo("");
    setInvoiceDate("");
    setInvoiceAmount("");
  };

  return (
    <div className="inv-container">
      <div className="inv-heading-panel shadow-sm mb-4">
        <div className="inv-heading-body">
          <h3 className="inv-heading-title">Invoices</h3>
        </div>
      </div>

      {/* FILTERS */}
      <div className="inv-filters d-flex flex-wrap gap-3">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            position: "relative",
          }}
        >
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            style={{
              position: "absolute",
              left: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "16px",  
              color: "#888",    
                        }}
          />
          <input
            type="text"
            className="inv-input"
            placeholder="Search Invoice No."
            value={invoiceNo}
            onChange={(e) => setInvoiceNo(e.target.value)}
            style={{
              height: "34px",
              padding: "6px 10px",
              paddingLeft: "50px", 
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            position: "relative",
          }}
        >
          <input
            type="date"
            className="inv-input"
            value={invoiceDate}
            onChange={(e) => setInvoiceDate(e.target.value)}
            style={{
             width:'200px',
              height: "34px",
              paddingLeft: "30px",
           
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            position: "relative",
          }}
        >
          <FontAwesomeIcon
            icon={faMagnifyingGlass}
            style={{
              position: "absolute",
              left: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "16px",  
              color: "#7c7979ff",    
            }}
          />
          <input
            type="text"
            className="inv-input"
            placeholder="Search Amount"
            value={invoiceAmount}
            onChange={(e) => setInvoiceAmount(e.target.value)}
            style={{
              height: "34px",
              padding: "6px 10px",
              paddingLeft: "50px", 
            
            }}
          />
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <button
            type="button"
            className="btn custom-btn"
            style={{
              backgroundColor: "#5db2e8",
              border: "none",
              color: "#fff",
              padding: "6px",
              cursor: "pointer",
              height: "40px",
            }}
            onClick={handleClear}
          >
            Clear
          </button>
        </div>
      </div>

      {/* INVOICE LIST PANEL */}
      <div className="inv-list-body">
        <div className="inv-table-wrapper">
          <table className="inv-table">
            <colgroup>
              <col />
              <col />
              <col />
              <col />
              <col style={{ width: "50px" }} />
            </colgroup>

            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>Sr.No</th>
                <th style={{ textAlign: "center" }}>
                  <a
                    className="inv-sort-link"
                    href="/accountant/invoice/index?sort=invoice_id"
                  >
                    Invoice Number
                  </a>
                </th>
                <th style={{ textAlign: "center" }}>
                  <a
                    className="inv-sort-link"
                    href="/accountant/invoice/index?sort=invoice_date"
                  >
                    Invoice Date
                  </a>
                </th>
                <th style={{ textAlign: "center" }}>
                  <a
                    className="inv-sort-link"
                    href="/accountant/invoice/index?sort=invoice_amount"
                  >
                    Invoice Amount
                  </a>
                </th>
                <th>
                  <span style={{ marginRight: "25px", float: "right" }}>
                    Action
                  </span>
                </th>
              </tr>
            </thead>

            <tbody>
              {[1, 2, 3, 4, 5].map((no) => (
                <tr key={no} style={{ height: "35px" }}>
                  <td style={{ textAlign: "center", padding: "6px 6px", fontSize: "14px" }}>{no}</td>
                  <td style={{ textAlign: "center", padding: "6px 6px", fontSize: "14px" }}>900</td>
                  <td style={{ textAlign: "center", padding: "6px 6px", fontSize: "14px" }}>Tue Aug 11 2020</td>
                  <td style={{ textAlign: "center", padding: "6px 6px", fontSize: "14px" }}>$ 1500</td>
                  <td style={{ textAlign: "center", position: "relative", padding: "6px 6px" }}>
                    <a
                      href="/accountant/invoice/Pending_Invoices_Invoice"
                      className="inv-view-btn"
                      style={{ marginLeft: "-30px" }}
                      onMouseEnter={() => setHoveredRow(no)}
                      onMouseLeave={() => setHoveredRow(null)}
                    >
                      <i className="bi bi-eye"></i>
                    </a>
                    {hoveredRow === no && (
                      <div
                        style={{
                          position: "absolute",
                          top: "-18px",
                          left: "35%",
                          transform: "translateX(-50%)",
                          backgroundColor: "#000",
                          color: "#fff",
                          padding: "2px 6px",
                          borderRadius: "3px",
                          fontSize: "11px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        View
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="wallet-main-footer">
            <ul className="wallet-main-pagination">
              <li className="wallet-main-active">
                <a href="#">1</a>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
            </ul>

            <div
              className="wallet-main-summary"
              style={{ marginRight: "1095px", marginTop: "-40px" }}
            >
              Showing <b>1-50</b> of <b>177</b> items.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Invoices;
